import { mutateGraphQL } from "~/hooks/graphql";

const ChangeCountryMutation = `
  mutation ChangeCountry($countryCode: String!) {
    updateCountry(input: { countryCode: $countryCode }) {
      status
      currencyCode
      isEuCountry
      isEuVerifyRequired
    }
  }
`;

/**
 * @returns Change Country Mutation response headers include set-cookie for country and currency. Used to set user location cookies.
 */
export const getChangeCountryMutationHandler = () => {
  const allData = mutateGraphQL(ChangeCountryMutation);

  return { mutationHandler: allData.mutationHandler };
}